import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { navLinks, supportLinks } from "../constants";
import { MdaiLink } from "./MdaiLink";
import { resolveCdnAssetUrl } from "../utils/cdnAssetUrl";

const GITHUB_LOGO_URL = resolveCdnAssetUrl("logo_github.svg");
const LINKEDIN_LOGO_URL = resolveCdnAssetUrl("logo_linkedin.svg");
const SLACK_LOGO_URL = resolveCdnAssetUrl("logo_slack.svg");
const YOUTUBE_LOGO_URL = resolveCdnAssetUrl("logo_youtube.svg");

const renderSocials = () => {
  return (
    <Stack
      direction="column"
      spacing={2}
      alignItems="flex-start"
      pb={5}
      sx={{
        width: { sm: "100%", lg: "35%" },
      }}
    >
      <Stack direction="row" spacing={3} justifyContent="flex-start" pb={3}>
        <Link
          href="https://www.linkedin.com/company/MyDecisive"
          target="_blank"
          rel="noopener,noreferrer"
        >
          <img alt="LinkedIn logo" style={{ height: "24px" }} src={LINKEDIN_LOGO_URL} />
        </Link>
        <Link
          href="https://github.com/MyDecisive"
          target="_blank"
          rel="noopener,noreferrer"
        >
          <img alt="Github logo" style={{ height: "24px" }} src={GITHUB_LOGO_URL} />
        </Link>
        <Link
          href="https://www.youtube.com/@MDAIProactiveOps"
          target="_blank"
          rel="noopener,noreferrer"
        >
          <img alt="YouTube logo" style={{ height: "24px" }} src={YOUTUBE_LOGO_URL} />
        </Link>
        <Link
          href="https://mydecisivecommunity.slack.com"
          target="_blank"
          rel="noopener,noreferrer"
        >
          <img alt="Slack logo" style={{ height: "24px" }} src={SLACK_LOGO_URL} />
        </Link>
      </Stack>
    </Stack>
  );
};

export function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        bottom: 0,
        left: 0,
        right: 0,
        p: 4,
        pt: { sm: 6, md: 10 },
        pb: { sm: 8, md: 15 },
        background: "var(--mdai-background-footer)",
        justifyContent: "center",
      }}
    >
      <Stack
        direction={{ sm: "column", lg: "row" }}
        spacing={2}
        alignItems="flex-start"
        justifyContent={{ sm: "flex-start", lg: "space-between" }}
        width="100%"
        maxWidth={1280}
      >
        <Stack
          direction={{ sm: "column", md: "row" }}
          gap={{ sm: 3, lg: 1 }}
          alignItems="stretch"
          justifyContent={{
            sm: "flex-start",
            lg: "space-evenly",
          }}
          width={{ sm: "100%", lg: "80%" }}
          sx={{
            flexWrap: { sm: "wrap", lg: "nowrap" },
            minWidth: { sm: "100%", lg: "1152px" },
          }}
        >
          <Stack direction="column">
            {navLinks.slice(0, 1).map(({ groupName, links }) => (
              <Stack
                key={groupName}
                direction="column"
                spacing={1}
                flexBasis="fit-content"
                alignItems="flex-start"
                width="auto"
                maxWidth={{ sm: "200px" }}
                sx={{
                  whiteSpace: "nowrap",
                  mb: 4,
                }}
              >
                <Typography variant="overline" color="#E1BEE7">
                  {groupName}
                </Typography>
                {links.map((link) => (
                  <MdaiLink
                    key={link.label}
                    label={link.label}
                    href={link.href}
                    color="primary"
                    style={{
                      gap: "0px",
                    }}
                  />
                ))}
              </Stack>
            ))}
          </Stack>
          {navLinks.slice(2, 5).map(({ groupName, links }) => (
            <Stack
              key={groupName}
              direction="column"
              spacing={1}
              alignItems="flex-start"
              flexBasis="fit-content"
              width="100%"
              maxWidth={{ sm: "200px" }}
              sx={{ whiteSpace: "wrap" }}
            >
              <Typography variant="overline" color="#E1BEE7">
                {groupName}
              </Typography>
              {links.map((link) => (
                <MdaiLink
                  key={link.label}
                  label={link.label}
                  href={link.href}
                  color="primary"
                  style={{ gap: "10px" }}
                />
              ))}
            </Stack>
          ))}
          <Stack direction="column">
            {navLinks.slice(5).map(({ groupName, links }) => (
              <Stack
                key={groupName}
                direction="column"
                spacing={1}
                alignItems="flex-start"
                flexBasis="fit-content"
                width="auto"
                maxWidth={{ sm: "200px" }}
                sx={{
                  whiteSpace: "nowrap",
                  mb: 4,
                }}
              >
                <Typography variant="overline" color="#E1BEE7">
                  {groupName}
                </Typography>
                {links.map((link) => (
                  <MdaiLink
                    key={link.label}
                    label={link.label}
                    href={link.href}
                    color="primary"
                    style={{ gap: "10px" }}
                  />
                ))}
              </Stack>
            ))}
          </Stack>
          <Stack
            key={supportLinks.groupName}
            direction="column"
            spacing={1}
            alignItems="flex-start"
            sx={{ whiteSpace: "nowrap" }}
          >
            <Typography variant="overline" fontWeight={600} color="#E1BEE7">
              {supportLinks.groupName}
            </Typography>
            <Stack sx={{ mb: 4 }}>
              {supportLinks.links.map((link) => (
                <Box key={link.label}>
                  {link.sublabel && (
                    <Typography
                      variant="body2"
                      sx={{ textWrap: "auto" }}
                      pb={1}
                      pt={2}
                    >
                      {link.sublabel}
                    </Typography>
                  )}
                  <MdaiLink
                    label={link.label}
                    href={link.href}
                    color="primary"
                    style={{ gap: "10px" }}
                  />
                </Box>
              ))}
            </Stack>
            {renderSocials()}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
